import {Maybe} from '#apollo/schema';
import {removeLastSubstringIfMatch} from '#util/stringUtils';

export const MAX_TIPS_CHAR_LENGTH = 350;

export const shortenTips = (tips: Maybe<string> | undefined): string => {
  if (!tips) return '';
  if (tips.length <= MAX_TIPS_CHAR_LENGTH) return tips;
  // Remove the last line if it's a bullet point
  const shortenedTips = removeLastSubstringIfMatch(
    tips.slice(0, MAX_TIPS_CHAR_LENGTH).trim(),
    '\n-',
  );
  // Remove the last period
  return `${removeLastSubstringIfMatch(shortenedTips, '.')} ...`;
};
